import { useEffect, useState } from "react";
import { getDistributionProcessesGrouped } from "@/Api/distributionProcesses";
import { DistributionProcessGrouped } from "@/types/distributionProcess";
import { TableData } from "@/App/DistributionHistory/Table";
import { ApiDataProps } from "@/pages/Tenants";
import PageTemplate from "@/components/PageTemplate";

export const DistributionHistory = () => {
  const [dataApi, setDataApi] = useState<ApiDataProps<DistributionProcessGrouped>>({
    data: [],
    current_page: 1,
    last_page: 1,
    total: 0,
    next_page_url: null,
    prev_page_url: null,
    from: 0,
    to: 0,
  } as ApiDataProps<DistributionProcessGrouped>);

  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (page: number = 1) => {
    setIsLoading(true);
    try {
      const response = await getDistributionProcessesGrouped(page);
      if (response.ok && response.data?.response) {
        setDataApi(response.data.response);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Erro ao buscar histórico de distribuições:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const pageActions = {
    next: () => {
      if (currentPage < dataApi.last_page) {
        fetchData(currentPage + 1);
      }
    },
    previous: () => {
      if (currentPage > 1) {
        fetchData(currentPage - 1);
      }
    },
    lastPage: () => {
      if (currentPage < dataApi.last_page) {
        fetchData(dataApi.last_page);
      }
    },
  };

  return (
    <PageTemplate>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Histórico Ações Distribuição</h1>
        </div>
        <TableData
          dataApi={dataApi}
          pageActions={pageActions}
          isLoading={isLoading}
        />
      </div>
    </PageTemplate>
  );
};
